<template>
  <div class="form-group form-row">
    <label :for="safeId()" class="col-sm-4 col-form-label">{{ label }}</label>
    <div class="col-sm-8">
      <record-select :id="safeId()" v-model="localValue" :dataset-id="datasetId"></record-select>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'record-select-group',
    props: {
      value: {required: true},
      label: {default: 'Record'},
      datasetId: {required: true}
    },
    data () {
      return {
        localValue: this.value
      }
    },
    watch: {
      localValue: function (val) {
        this.$emit('input', val)
      },
      value: function (val) {
        this.localValue = val
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ui/record-select-group.vue